export default __webpack_public_path__ + "static/banner-car-safety-made-easy-technology-and-tips-3eef5fde674c02d7dc17072501b5e50a.jpg";